import React, { useEffect, useState } from "react";
import "./Home.scss";
import { Container, Segment, Dimmer, Loader } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateGooglePlatform,
  updatePlatform,
  setLanding,
  trackSession,
} from "../../actions";
import { withRouter } from "react-router";
import Favicon from "react-favicon";
import NotFound from "../404Page/NotFound";
import { isMobile } from "react-device-detect";
import MetaTags from "react-meta-tags";
//Reselect
import { createStructuredSelector } from "reselect";
import { selectLandingData } from "../../selectors/landing.selector";
import { selectError } from "../../selectors/error.selector";
// Utils
import { addhttp } from "../utils/functions";
import {
  selectUrlParams,
  selectEmbedded,
  selectMode,
} from "../../selectors/global.selector";
import DefaultDesktopLanding from "../../images/DefaultDesktop.png";
import DefaultMobileLanding from "../../images/DefaultMobile.png";
import InformationButton from "../../images/information-button.svg";
import { setPageVisit } from "../utils/Amplitude";
import { HomeDiv } from "../styled-components";
import { allPlatforms,platformStrategy } from "../utils/sharing";
import Footer from "../Footer/Footer";

const Home = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const campaignId = props.match.params.campaignId;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const value = urlParams.get("v");
  const url = urlParams.get("url");
  const wp = (urlParams.get("wp") === "true");
  const [displayEmptyPage, setDisplayEmptyPage] = useState(false);

  const structuredSelector = createStructuredSelector({
    landingData: selectLandingData,
    urlParam: selectUrlParams,
    apiMode: selectMode,
    error: selectError,
  });
  const selectedState = structuredSelector(state);
  const { landingData, urlParam, apiMode, error } = selectedState;
  const whitelabel =
    landingData && landingData.whitelabel ? landingData.whitelabel : {};

  const toReadyPlatform = (platform) => {
    const strategy = platformStrategy(platform);

    const newUrl = `/campaign/${campaignId}/ready_made_post/${platform}` + (urlParam ?? "");
    if(wp) {
      history.replace({
        pathname: newUrl,
        state: { value, url },
      });
    } else {
      history.push({
        pathname: newUrl,
        state: { value, url },
      });
    }

    dispatch(updateGooglePlatform(strategy.config.platformName));
    dispatch(updatePlatform(platform));
  };

  useEffect(() => {
    dispatch(setLanding(campaignId, apiMode));
    dispatch(trackSession({ campaignID: campaignId, wp }, apiMode));
    setPageVisit({ Page: "Landing" });
  }, []);

  useEffect(() => {
    if(wp) {
      document.body.style.backgroundColor = "transparent";
      document.body.style.background = "transparent";
    }

    if (wp && landingData) {
      if (
        landingData.metadata.supportedReadyMadeSocialNetworks.twitter
      ) {
        toReadyPlatform("twitter");
      } else if (
        landingData.metadata.supportedReadyMadeSocialNetworks.linkedin
      ) {
        toReadyPlatform("linkedin");
      } else if (
        landingData.metadata.supportedReadyMadeSocialNetworks.facebook
      ) {
        toReadyPlatform("facebook");
      } else if (
        landingData.metadata.supportedReadyMadeSocialNetworks.instagram
      ) {
        toReadyPlatform("instagram");
      } else if (
        landingData.metadata.supportedReadyMadeSocialNetworks.whatsapp
      ) {
        toReadyPlatform("whatsapp");
      } else {
        // show just transparent page
        setDisplayEmptyPage(true);
      }
    }
  }, [wp,landingData]);

  return (
    <>
      {error ? (
        <NotFound />
      ) : (
        <>
          {displayEmptyPage ?
          <>
          </>          
          : landingData ? (
            <HomeDiv
              font={whitelabel.fontFamily}
              radius={whitelabel.buttonCornerRadius}
              className={`home${isMobile ? " mobile":""}`}
            >
              <MetaTags>
                <title>
                  {landingData.whitelabel
                    ? `${landingData.campaign.name} | ${landingData.whitelabel.headTitle}`
                    : landingData.campaign.name}
                </title>
                <meta name="description" content="Some description." />
                <meta property="og:type" content="website" />
                <meta
                  property="og:image"
                  itemProp="image"
                  content={landingData.metadata.clientImageURL}
                />
                <meta
                  property="og:image:secure_url"
                  itemProp="image"
                  content={landingData.metadata.clientImageURL}
                />
                <meta
                  property="og:title"
                  content={landingData.campaign.facebookTitle}
                />
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                  name="twitter:image"
                  content={landingData.metadata.clientImageURL}
                />
                <meta
                  name="twitter:title"
                  content={landingData.campaign.facebookTitle}
                />
              </MetaTags>
              <Favicon
                url={
                  landingData.whitelabel && landingData.whitelabel.faviconURL
                    ? landingData.whitelabel.faviconURL
                    : "https://pic.speechifai.tech/F9E45BF4-38BE-4FFF-9740-BCC99D681563.jpg"
                }
              />

              <div className="img-container">
                {isMobile ? (
                  <img
                    src={
                      landingData.metadata.clientImagePortraitURL
                        ? landingData.metadata.clientImagePortraitURL
                        : landingData.metadata.clientImageURL
                        ? landingData.whitelabel &&
                          landingData.whitelabel.landingImageURL
                        : DefaultMobileLanding
                    }
                    data-cy="landing-image"
                    alt={
                      landingData.campaign.clientName
                        ? landingData.campaign.clientName
                        : landingData.campaign.name
                    }
                  />
                ) : (
                  <img
                    src={
                      landingData.metadata.clientImageURL
                        ? landingData.metadata.clientImageURL
                        : landingData.whitelabel &&
                          landingData.whitelabel.landingImageURL
                        ? landingData.whitelabel.landingImageURL
                        : DefaultDesktopLanding
                    }
                    data-cy="landing-image"
                    alt={
                      landingData.campaign.clientName
                        ? landingData.campaign.clientName
                        : landingData.campaign.name
                    }
                  />
                )}
              </div>

              <div className="campaign-overlay">
                <Container className="home-container">
                  {landingData.campaign.campaignInfoUrl && (
                    <a
                      className="info-container"
                      href={addhttp(landingData.campaign.campaignInfoUrl)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={InformationButton} alt="More Information" />
                    </a>
                  )}

                  <div className="home-container-top">
                    <div className={`home-container-introduction${landingData.campaign.welcomeMessage?.length >= 400 ? " long-text" : ""}`}>
                      <h1>{landingData.campaign.welcomeMessage}</h1>
                    </div>

                    <div className="home-container-bottom">
                      {landingData.whitelabel ? (
                        <div className="home-container-question">
                          <h3>
                            {landingData.whitelabel.landingPageSocialPlatform}
                          </h3>
                        </div>
                      ) : (
                        <div className="home-container-question">
                          <h3>What social platform would you like to use?</h3>
                        </div>
                      )}

                      <div className="home-container-socials">
                        {allPlatforms.map((platform) => {
                          if(landingData.metadata.supportedReadyMadeSocialNetworks[platform]) {
                            const strategy = platformStrategy(platform);

                            if(!strategy.config.onlyMobile || isMobile) {
                            return <>
                              <button
                                className="social-desktop-button generic-btn"
                                onClick={() => toReadyPlatform(platform)}
                                style={{
                                  "--platform_color": strategy.config.color,
                                }}
                              >
                                <span className="social-desktop-button-text">
                                  {platform === "twitter" 
                                    ? <img src={strategy.res.icon} className="icon"></img>
                                    : <i className={(strategy.res.icon ? strategy.res.icon : platform) + " icon"}></i>
                                  }
                                  {platform !== "native" ? strategy.config.platformName : "All Apps"}
                                  
                                </span>
                            </button>
                              
                              </>;
                            }
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </Container>
                <Footer {...landingData} />
              </div>
              
            </HomeDiv>
          ) : (
            <div className="home-loader">
                <Dimmer 
                  active 
                  inverted 
                  style={{ backgroundColor: "transparent" }}
                >
                  <Loader inverted>Loading Campaign</Loader>
                </Dimmer>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default withRouter(Home);
